import http from 'plugins/axios';

export default {
  reqList(data) {
    return http.get({
      url: '/la/admin/pledge/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/pledge/add',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/pledge/update',
      data
    });
  },
  getCoinTypes() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  }
  // remove(data) {
  //   return http.get({
  //     url: '/la/admin/pledge/deleteById',
  //     data: {
  //       id: data
  //     }
  //   });
  // }
};
